module.exports = __webpack_public_path__ + "img/preview-list.61a32423.png";